import { Routes, RouterModule } from '@angular/router';

// Imports Components:
import { PageNotFoundComponent } from './components/shared/pages-errors/page-not-found/page-not-found.component';
import { PageInternalServerErrorComponent } from './components/shared/pages-errors/page-internal-server-error/page-internal-server-error.component';
import { ReporteAnalisisHabilidadComponent } from './components/reporte-analisis-habilidad/reporte-analisis-habilidad.component';
import { ReporteCertificadoOcupacionalComponent } from './components/reporte-certificado-ocupacional/reporte-certificado-ocupacional.component';
import { ReporteSomaComponent } from './components/reporte-soma/reporte-soma.component';
import { ReporteConsolidadoLaboratorioComponent } from './components/reporte-consolidado-laboratorio/reporte-consolidado-laboratorio.component';
import { HistoriaCenpresabilComponent } from './components/historia-cenpresabil/historia-cenpresabil.component';
import { ReporteCitasLaboratorioComponent } from './components/reporte-citas-laboratorio/reporte-citas-laboratorio.component';
import { ReporteInconformidadAgendaComponent } from './components/reporte-inconformidad-agenda/reporte-inconformidad-agenda.component';
import { ReporteOrdenesSinAgendaComponent } from './components/reporte-ordenes-sin-agenda/reporte-ordenes-sin-agenda.component';
import { ReporteComfenalcoComponent } from './components/reporte-comfenalco/reporte-comfenalco.component';
import { ReporteResolucion1552Component } from './components/reporte-resolucion1552/reporte-resolucion1552.component';
import { ReportePulseraComponent } from './components/reporte-pulsera/reporte-pulsera.component';
import { ReporteResolucion0256Component } from './components/reporte-resolucion0256/reporte-resolucion0256.component';
import { ReporteNotasEnfermeriaComponent } from './components/reporte-notas-enfermeria/reporte-notas-enfermeria.component';
import { ReporteFormatoPagareComponent } from './components/reporte-formato-pagare/reporte-formato-pagare.component';
import { ReporteSolicitudesSuministrosComponent } from './components/reporte-solicitudes-suministros/reporte-solicitudes-suministros.component';
import { ReporteImprimirAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-imprimir-admision/reporte-imprimir-admision.component';

import { ReporteProcedimientosAdmisionesComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-procedimientos-admisiones/reporte-procedimientos-admisiones.component';
import { ReporteMedicamentosHomologadosComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-medicamentos-homologados/reporte-medicamentos-homologados.component';
import { ReporteRegistroMedicamentosInsumosComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-registro-medicamentos-insumos/reporte-registro-medicamentos-insumos.component';
import { ReporteOrdenesMedicasComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-ordenes-medicas/reporte-ordenes-medicas.component';
import { ReporteSolicitudPendienteMedicamentosComponent} from './components/reportes-admisiones/procesos-admisiones/reporte-solicitud-pendiente-medicamentos/reporte-solicitud-pendiente-medicamentos.component';
import { ReporteControlDietaComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-control-dieta/reporte-control-dieta.component';
import { ReporteOrdenAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-orden-admision/reporte-orden-admision.component';
import { ReporteAltaVoluntariaComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-alta-voluntaria/reporte-alta-voluntaria.component';
import { ReporteRecordatorioCitasComponent } from './components/reportes-citas/reporte-recordatorio-citas/reporte-recordatorio-citas.component';
import { ReporteRecordatorioCitasSComponent } from './components/reportes-citas/reporte-recordatorio-citas-s/reporte-recordatorio-citas-s.component';
import { ReporteFacturaVentaComponent } from './components/reportes-facturacion/reporte-factura-venta/reporte-factura-venta.component';

import { ReporteOrdenSuministroAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-orden-suministro-admision/reporte-orden-suministro-admision.component';

import { ReporteNotificacionDevolucionMedicamentosComponent} from './components/reporte-notificacion-devolucion-medicamentos/reporte-notificacion-devolucion-medicamentos.component';
import { ReporteFormatoAsistencialComponent } from './components/reporte-formato-asistencial/reporte-formato-asistencial.component';
import { ReporteComprobanteInformeDiarioDianComponent } from './components/reporte-comprobante-informe-diario-dian/reporte-comprobante-informe-diario-dian.component';
import { ComprobanteInformeDiarioResumidoComponent } from './components/reporte-comprobante-informe-diario-dian/comprobante-informe-diario-resumido/comprobante-informe-diario-resumido.component';
import { ReporteAnticipoComponent } from './components/reporte-anticipo/reporte-anticipo.component';
import { ReporteAnexoIIComponent } from './components/reporte-anexo-ii/reporte-anexo-ii.component';
import { ReporteCuentaCobroDomicilioComponent } from './components/reporte-cuenta-cobro-domicilio/reporte-cuenta-cobro-domicilio.component';
import { ReporteAdmision2Component } from './components/reportes-admisiones/procesos-admisiones/reporte-admision2/reporte-admision2.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { PageTokenInvalidateComponent } from './components/shared/pages-errors/page-token-invalidate/page-token-invalidate.component';
import { ReporteEncuestaCovidComponent } from './components/reporte-encuesta-covid/reporte-encuesta-covid.component';
import { ReporteAdmisionesAbiertasComponent } from './components/reportes-admisiones/reporte-admisiones-abiertas/reporte-admisiones-abiertas.component';
import { ReporteEpicrisisComponent } from './components/reporte-epicrisis/reporte-epicrisis.component';
import { ReporteAdmisionesAbiertasCreacionComponent } from './components/reportes-admisiones/reporte-admisiones-abiertas-creacion/reporte-admisiones-abiertas-creacion.component';
import { ReporteRibisoftComponent } from './components/reportes-facturacion/reporte-ribisoft/reporte-ribisoft.component';
import { FormulasMedicasEvolucionesComponent } from './components/reportes-solicitud-servicios/reporte-formulas-medicas/formulas-medicas-evoluciones/formulas-medicas-evoluciones.component';
import { FormulasMedicasHcComponent } from './components/reportes-solicitud-servicios/reporte-formulas-medicas/formulas-medicas-hc/formulas-medicas-hc.component';
import { ReporteOrdenMedicaComponent } from './components/reportes-solicitud-servicios/reporte-orden-medica/reporte-orden-medica.component';
import { ReporteOrdenEscritasComponent } from './components/reportes-ordenamientos/reporte-orden-escritas/reporte-orden-escritas.component';
import { ReporteOrdenServiciosComponent } from './components/reportes-ordenamientos/reporte-orden-servicios/reporte-orden-servicios.component';
import { ReporteOrdenMedicamentosComponent } from './components/reportes-ordenamientos/reporte-orden-medicamentos/reporte-orden-medicamentos.component';
import { ReporteOrdenGeneralComponent } from './components/reportes-ordenamientos/reporte-orden-general/reporte-orden-general.component';
import { PreguntaAsistencialComponent } from './components/reporte-formato-asistencial/pregunta-asistencial/pregunta-asistencial.component';
import { ReporteIntegracionHcComponent } from './components/reporte-integracion-hc/reporte-integracion-hc.component';
import { ReporteCaptacionComponent } from './components/reporte-captacion/reporte-captacion.component';
import { ReporteCarteraPacientesComponent } from './components/reporte-cartera-pacientes/reporte-cartera-pacientes.component';
import { ReporteRecordatorioCitasPosComponent } from './components/reportes-citas/reporte-recordatorio-citas-pos/reporte-recordatorio-citas-pos.component';
import { ReporteEntregaMedicamentosComponent} from './components/reportes-facturacion/reporte-entrega-medicamentos/reporte-entrega-medicamentos.component';
import { AdmisionComponent } from './components/reporte-formato-asistencial/admision/admision.component';
import { ReporteOrdenMedicamentosControladosComponent } from './components/reportes-ordenamientos/reporte-orden-medicamentos-controlados/reporte-orden-medicamentos-controlados.component';
import { ReporteHistoriaComponent } from './components/reporte-historia/reporte-historia.component';
import { ReporteIncapacidadComponent } from './components/reporte-incapacidad/reporte-incapacidad.component';
import { ReporteIncapacidad1427Component } from './components/reporte-incapacidad1427/reporte-incapacidad1427.component';
import { ReporteEvolucionComponent } from './components/reporte-evolucion/reporte-evolucion.component';
import { ReporteDemandaInducidaComponent } from './components/reporte-demanda-inducida/reporte-demanda-inducida.component';
import { ReportePreguntaComponent } from './components/reporte-pregunta/reporte-pregunta.component';
import {RelacionAdmisionesComponent} from './components/reportes-admisiones/relacion-admisiones/relacion-admisiones.component';
import {MovimientoPacienteByRangoFechaComponent} from './components/reportes-admisiones/movimiento-paciente-by-rango-fecha/movimiento-paciente-by-rango-fecha.component';
import { ReporteInteropereabilidadHcComponent } from './components/reporte-interopereabilidad-hc/reporte-interopereabilidad-hc.component';



const routesMain: Routes = [
  {
    path: 'analisis-habilidad/:codigoBaseDatos/:id',
    component: ReporteAnalisisHabilidadComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-cenpresabil/:codigoBaseDatos/:id/:idEntidad',
    component: ReporteCertificadoOcupacionalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-soma/:codigoBaseDatos/:idLogin/:sma',
    component: ReporteSomaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'consolidado-laboratorio/:codigoBaseDatos/:fechaInicial/:fechaFinal/:sede/:user',
    component: ReporteConsolidadoLaboratorioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'historia-cenpresabil/:codigoBaseDatos/:id/:idEntidad',
    component: HistoriaCenpresabilComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'citas-laboratorio/:codigoBaseDatos/:spa/:user',
    component: ReporteCitasLaboratorioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'inconformidad-agenda/:codigoBaseDatos/:spa/:user',
    component: ReporteInconformidadAgendaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ordenes-sin-agenda/:codigoBaseDatos/:sede/:user',
    component: ReporteOrdenesSinAgendaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-comfenalco/:codigoBaseDatos',
    component: ReporteComfenalcoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-resolucion1552/:codigoBaseDatos/:uncoSede/:uncoEntidad/:user',
    component: ReporteResolucion1552Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-pulsera/:codigoBaseDatos/:idAdm',
    component: ReportePulseraComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-resolucion0256/:codigoBaseDatos/:uncoSede/:uncoEntidad/:user',
    component: ReporteResolucion0256Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-notas-enfermeria/:codigoBaseDatos/:uncoSede/:uncoEntidad',
    component: ReporteNotasEnfermeriaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-formato-pagare/:codigoBaseDatos/:uncoSede/:uncoEntidad/:uncoAdmision',
    component: ReporteFormatoPagareComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-solicitudes-suministros/:codigoBaseDatos/:uncoAdmisionInspecciona/:uncoSede/:uncoLogin',
    component: ReporteSolicitudesSuministrosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-imprimir-admision/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteImprimirAdmisionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-procedimientos-admision/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteProcedimientosAdmisionesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-medicamentos-homologados/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteMedicamentosHomologadosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-registro-medicamentos-insumos/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteRegistroMedicamentosInsumosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-ordenes-medicas/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteOrdenesMedicasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-solicitud-pendientes-medicamentos/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteSolicitudPendienteMedicamentosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-control-dieta/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteControlDietaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-orden-admision/:codigoBaseDatos/:uncoSede/:uncoLogin/:consecutivo',
    component: ReporteOrdenAdmisionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-alta-voluntaria/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteAltaVoluntariaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-recordatorio-citas/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoCirugia',
    component: ReporteRecordatorioCitasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-recordatorio-citas-s/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoCirugia',
    component: ReporteRecordatorioCitasSComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-factura-venta/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoTransaccion/:tipoDocumento',
    component: ReporteFacturaVentaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-orden-suministros-admision/:codigoBaseDatos/:uncoSede/:uncoLogin/:consecutivo',
    component: ReporteOrdenSuministroAdmisionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-notificacion-devolucion-medicamentos/:codigoBaseDatos/:uncoLogin/:uncoEntidad/:uncoAdm',
    component: ReporteNotificacionDevolucionMedicamentosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-formato-asistencial/:codigoBaseDatos/:uncoLogin/:uncoSede/:tta',
    component: ReporteFormatoAsistencialComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-formato-asistencial/:codigoBaseDatos/:uncoLogin/:uncoSede/:tta/:evoluciones/:servicios',
    component: ReporteFormatoAsistencialComponent,
    canActivate: [AuthGuard],
  },
  {
    path : 'reporte-historia-admision/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component : AdmisionComponent,
    canActivate : [ AuthGuard]
  },
  {
    path: 'reporte-formato-pregunta/:codigoBaseDatos/:uncoLogin/:uncoSede/:tta/:pregunta',
    component: PreguntaAsistencialComponent,
    canActivate: [AuthGuard],
  },
  {
    path : 'reporte-historia/:codigoBaseDatos/:uncoLogin/:uncoSede/:tta',
    component: ReporteHistoriaComponent,
    canActivate: [AuthGuard],
  },
  {
    path : 'reporte-pregunta/:codigoBaseDatos/:uncoLogin/:uncoSede/:tta/:nodo',
    component: ReportePreguntaComponent,
    canActivate: [AuthGuard],
  },
  {
    path : 'reporte-evolucion/:codigoBaseDatos/:uncoLogin/:uncoSede/:tta',
    component: ReporteEvolucionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reporte-control-dieta/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteControlDietaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-orden-admision/:codigoBaseDatos/:uncoSede/:uncoLogin/:consecutivo',
    component: ReporteOrdenAdmisionComponent,
    canActivate: [AuthGuard],
  },
  {
    path:
      'reporte-alta-voluntaria/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteAltaVoluntariaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reporte-recordatorio-citas/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoCirugia',
    component: ReporteRecordatorioCitasComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reporte-recordatorio-citas-s/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoCirugia',
    component: ReporteRecordatorioCitasSComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'reporte-recordatorio-citas-pos/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoCirugia',
    component : ReporteRecordatorioCitasPosComponent,
    canActivate : [ AuthGuard]
  },
  {
    path: 'reporte-factura-venta/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoTransaccion/:tipoDocumento',
    component: ReporteFacturaVentaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-orden-suministros-admision/:codigoBaseDatos/:uncoSede/:uncoLogin/:consecutivo',
    component: ReporteOrdenSuministroAdmisionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-notificacion-devolucion-medicamentos/:codigoBaseDatos/:uncoLogin/:uncoEntidad/:uncoAdm',
    component: ReporteNotificacionDevolucionMedicamentosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-comprobante-informe-diario-dian/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteComprobanteInformeDiarioDianComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-comprobante-informe-diario-dian/:codigoBaseDatos/:uncoSede/:uncoLogin/resumido',
    component: ComprobanteInformeDiarioResumidoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-anticipo/:codigoBaseDatos/:uncoSede/:uncoLogin/:consecutivoAdmision',
    component: ReporteAnticipoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-anticipo/:codigoBaseDatos/:uncoSede/:uncoLogin/:consecutivoAdmision/:uncoAnticipo',
    component: ReporteAnticipoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-anexo-II/:codigoBaseDatos/:uncoAtencionInicialUrgencia/:isOriginal',
    component: ReporteAnexoIIComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-cuenta-cobro-domicilio/:codigoBaseDatos/:uncoSede/:uncoLogin/:profesional/:uncoRango',
    component: ReporteCuentaCobroDomicilioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-admision-2/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision',
    component: ReporteAdmision2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-encuesta-covid/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAfiliado',
    component: ReporteEncuestaCovidComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-admisiones-abiertas/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteAdmisionesAbiertasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-admisiones-abiertas-creacion/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteAdmisionesAbiertasCreacionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-epicrisis/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoHistoria',
    component: ReporteEpicrisisComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-ribisoft/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteRibisoftComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-formulas-medicas/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoHistoria',
    component: FormulasMedicasHcComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-formulas-medicas-evolucion/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoEvolucion',
    component: FormulasMedicasEvolucionesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-orden-medicas/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoHistoria',
    component: ReporteOrdenMedicaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-orden-medicas-evolucion/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoEvolucion',
    component: ReporteOrdenMedicaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reporte-ordenes-escritas/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision/:uncoTransaccion/:uncoHc',
    component: ReporteOrdenEscritasComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-ordenes-servicios/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision/:uncoTransaccion/:uncoHc',
    component: ReporteOrdenServiciosComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-ordenes-medicamentos/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision/:uncoTransaccion/:uncoHc',
    component: ReporteOrdenMedicamentosComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-ordenes-general/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoAdmision/:uncoTransaccion/:uncoHc',
    component: ReporteOrdenGeneralComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-integracion-hc/:codigoBaseDatos/:uncoParametroSimens/:uncoAfiliado',
    component: ReporteIntegracionHcComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-interoperabilidad-hc/:codigoBaseDatos/:uncoSede/:numeroDoc/:tipoDoc',
    component:  ReporteInteropereabilidadHcComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-captacion/:codigoBaseDatos/:uncoSede/:user',
    component: ReporteCaptacionComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-cartera-pacientes/:codigoBaseDatos/:uncoSede/:user',
    component: ReporteCarteraPacientesComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-entrega-medicamentos/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component: ReporteEntregaMedicamentosComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-orden-medicamentos-controlados/:codigoBaseDatos/:uncoSede/:uncoLogin/:uncoHc',
    component: ReporteOrdenMedicamentosControladosComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-incapacidad/:codigoBaseDatos/:unco/:uncoSede/:tipo',
    component: ReporteIncapacidadComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'reporte-incapacidad-1427/:codigoBaseDatos/:unco/:uncoSede/:tipo',
    component: ReporteIncapacidad1427Component,
    canActivate: [ AuthGuard ]
  },
  {
    path : 'reporte-demanda-inducida/:codigoBaseDatos/:uncoSede/:uncoHistoria/:user',
    component : ReporteDemandaInducidaComponent,
    canActivate: [ AuthGuard]
  },
  {
    path : 'reporte-relacion-admisiones/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component : RelacionAdmisionesComponent,
    canActivate: [ AuthGuard]
  },
  {
    path : 'reporte-movimiento-paciente-by-rango-fecha/:codigoBaseDatos/:uncoSede/:uncoLogin',
    component : MovimientoPacienteByRangoFechaComponent,
    canActivate: [ AuthGuard]
  },
  { path: 'login', component: LoginComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: 'page-token-expire', component: PageTokenInvalidateComponent },
  {
    path: 'page-internal-server-error',
    component: PageInternalServerErrorComponent,
  },
  { path: '**', pathMatch: 'full', redirectTo: 'page-not-found' },
];
export const ROUTES_MAIN = RouterModule.forRoot(routesMain, { useHash: true });
